import { render, staticRenderFns } from "./select-oauth-app.vue?vue&type=template&id=b9628410&"
import script from "./select-oauth-app.vue?vue&type=script&lang=js&"
export * from "./select-oauth-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports